import { render, staticRenderFns } from "./ButtonTooltipDelete.vue?vue&type=template&id=73b05c0c"
import script from "./ButtonTooltipDelete.vue?vue&type=script&lang=js"
export * from "./ButtonTooltipDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports